import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getDeletedDocTracker } from "../../../services/PharmacyUser";
import dayjs from "dayjs";
import PreviewDeletedDoc from "./PreviewDeletedDoc";

const DeletedDocsTracker = (props) => {
  const [rows, setRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [document, setDocument] = useState({});

  useEffect(() => {
    getDeletedDocTracker().then((res) => {
      setRows(
        res.data.map((row) => ({
          ...row,
          actionDetails: JSON.parse(row.actionDetails),
          actionDate: dayjs(row.actionDate).format("YYYY-MM-DD hh:mm a"),
          firstName: row.userDetails.first,
          lastName: row.userDetails.last,
          email: row.userDetails.email,
          phone: row.userDetails.phone,
          type: row.userDetails.type,
          active: row.userDetails.active ? true : false,
        }))
      );
    });
  }, []);

  const handleDocCLick = (row) => {
    console.log("row clicked", row.actionDetails);
    setIsOpen(true);
    setDocument(row.actionDetails);
  };

  const columns = [
    { field: "actionDate", headerName: "Action Date", width: 180 },
    {
      field: "DocumentName",
      headerName: "Document Name",
      width: 200,
      valueGetter: (params) => {
        return params.row.actionDetails.name;
      },
      renderCell: (params) => {
        return (
          <button
            className="fw-bold btn btn-link text-primary text-decoration-none"
            onClick={() => handleDocCLick(params.row)}>
            {params?.row?.actionDetails?.name}
          </button>
        );
      },
    },
    { field: "actionType", headerName: "Action Type", width: 130 },
    { field: "actionUser", headerName: "Action User ID", width: 120 },
    { field: "firstName", headerName: "First Name", width: 130 },
    { field: "lastName", headerName: "Last Name", width: 130 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "type", headerName: "User Type", width: 150 },
    {
      field: "active",
      headerName: "Active Status",
      width: 120,
      type: "boolean",
    },
  ];

  const paginationModel = { page: 0, pageSize: 50 };

  return (
    <div>
      {isOpen ? (
        <div>
          <button
            className="btn btn-success mb-3 mx-3"
            onClick={() => {
              setIsOpen(false);
              setDocument({});
            }}>
            Back
          </button>
          <PreviewDeletedDoc
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            document={document}
          />
        </div>
      ) : (
        <div className="dg_1liner">
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            slots={{ toolbar: GridToolbar }}
          />
        </div>
      )}
    </div>
  );
};

export default DeletedDocsTracker;
